import { Form, Formik } from "formik";
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { useLocale } from '../../../contexts/localeContext';
import WizardSideBarStep from '../../../models/WizardSideBarStep';
import { updateButtonData } from '../../../services/biometricPresetService';
import { showError } from "../../../services/utilities/ServiceError";
import { toast } from "react-toastify";
import { useDialog } from '../../dialog/DialogContext';
import Wizard from '../../wizard/wizard';
import ButtonConfigEditStep from './ButtonConfigEditStep';
import ButtonSummary from './Summary';
import ButtonConfigWizard from "./ButtonConfigWizard";

interface ButtonConfigModalProps {
    isOpen: boolean,
    onClose: () => void,
    rowData: any,
    setBusy: (busy: boolean) => void
}

const ButtonConfigModal: FC<ButtonConfigModalProps> = ({ isOpen, onClose, rowData, setBusy }) => {

    return (<Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <ButtonConfigWizard rowData={rowData} onClose={onClose} setBusy={setBusy} />
    </Modal>);
}

export default ButtonConfigModal;
